<template>
    <form class="card mt-2" id="genInfo" @submit.prevent="confirmUpdateGeneralInfo">
        <div class="card-body">
            <div class="card-title font-weight-bold">
                General Information
                <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
<!--                  v-if="crew.active == 1 || isSystemAdmin"-->
                  <template v-if="crew.active == 1 || isSystemAdmin">
                    <button v-if="editable"
                            class="btn btn-sm btn-xs btn-danger float-right ml-2"
                            @click="cancelEdit"
                    >
                        <span class="fas fa-ban"></span>
                    </button>
                    <button type="submit"
                            class="btn btn-sm btn-xs btn-warning font-weight-bold float-right mb-1"
                            @mouseenter="highlighFields('genInfo', true)"
                            @mouseleave="highlighFields('genInfo', false)"
                    >
                        <span class="fas fa-user-edit"></span>
                        {{editable ? 'Update' :'Edit Info'}}
                    </button>
                  </template>
                </template>
                <hr class="mt-1 border-dark"/>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.last_name}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="last_name"
                >
                    Last Name:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="last_name"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"

                           :readonly="!editable"
                           v-model="crewEdit.last_name"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.last_name !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.last_name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.first_name}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="first_name"
                >
                    First Name:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="first_name"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.first_name"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.first_name !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.first_name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.middle_name}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="middle_name"
                >
                    Middle Name:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="middle_name"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.middle_name"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.middle_name !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.middle_name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.extension}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="extension"
                >
                    Suffix:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="extension" name="extension" readonly
                           v-if="!editable"
                           class="form-control form-control-xs form-display h-1x"
                           v-model="crewEdit.extension"
                    >
                    <select class="form-control form-control-xs custom-select" id="suffix"
                            v-else
                            v-model="crewEdit.extension"
                    >
                        <option :value="null">--- Suffix ---</option>
                        <option :value="nameExtension" v-for="(nameExtension, index) in nameExtensions" :key="index">
                            {{ nameExtension }}
                        </option>
                    </select>
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.extension !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.extension }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.nickname}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="nickname"
                >
                    Nickname:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="nickname"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.nickname"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.nickname !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.nickname }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.rank}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="male"
                >
                    Gender:
                </label>
                <div class="col col-sm-4">
                    <select id="male"
                            v-if="editable"
                            class="form-control form-control-xs h-1x p-0"
                            v-model="crewEdit.male"
                    >
                        <option :value="1">Male</option>
                        <option :value="0">Female</option>
                    </select>

                    <input v-else
                           type="text" readonly id="male"
                           class="form-control form-control-xs form-display h-1x"
                           :value="crewEdit.male ?'Male' :'Female' "
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.rank !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.rank }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.birthdate}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="birthdate"
                >
                    Birth Date:
                </label>
                <div class="col col-sm-4">
                    <input type="date"
                           class="form-control form-control-xs h-1x"
                           v-if="editable"
                           v-model="crewEdit.birthdate"
                    >
                    <input v-else
                           type="text" id="birthdate" readonly
                           class="form-control form-control-xs form-display h-1x"
                           :value="crewEdit.birthdate | moment('D MMM YYYY')"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.birthdate !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.birthdate }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="age"
                >
                    Age:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="age" readonly
                           class="form-control form-control-xs form-display h-1x"
                           :value="crewAge"
                    >
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.birthplace}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="birth_place"
                >
                    Birth Place:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="birth_place"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.birthplace"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.birthplace !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.birthplace }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.civil_status_id}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="civil_status"
                >
                    Civil Status:
                </label>
                <div class="col col-sm-4">
                    <select id="civil_status" v-if="editable"
                            class="form-control form-control-xs h-1x p-0"
                            v-model="crewEdit.civil_status_id"
                    >
                        <option :value="null">------</option>
                        <option v-for="civilStatusKey in civilStatusKeys" :key="civilStatusKey.id"
                                :value="civilStatusKey.id"
                        >{{ civilStatusKey.name }}</option>
                    </select>
                    <input v-else type="text" id="civil_status" readonly
                           class="form-control form-control-xs form-display h-1x"
                           :value="crewEdit.civil_status ? crewEdit.civil_status.name : '------'"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.civil_status_id !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.civil_status_id }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.civil_status}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="nationality"
                >
                    Nationality:
                </label>
                <div class="col col-sm-4">
                    <select id="nationality" v-if="editable"
                            class="form-control form-control-xs h-1x p-0"
                            v-model="crewEdit.country_id"
                    >
                        <option :value="null">------</option>
                        <option
                                v-for="natlKey in natlKeys" :key="natlKey.id"
                                :value="natlKey.id"
                        >{{ natlKey.natl }}</option>
                    </select>

                    <input v-else type="text" id="nationality" readonly
                           class="form-control form-control-xs form-display h-1x"
                           :value=" crewEdit.country ? crewEdit.country.natl : '------'"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.country_id !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.country_id }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.religion_id}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="religion"
                >
                    Religion:
                </label>
                <div class="col col-sm-4">
                    <select id="religion" v-if="editable"
                            class="form-control form-control-xs h-1x p-0"
                            v-model="crewEdit.religion_id"
                    >
                        <option :value="null">------</option>
                        <option
                                v-for="religionKey in religionKeys" :key="religionKey.id"
                                :value="religionKey.id"
                        >{{ religionKey.name }}</option>
                    </select>

                    <input v-else type="text" id="religion" readonly
                           class="form-control form-control-xs form-display h-1x"
                           :value="crewEdit.religion ? crewEdit.religion.name : '------'"
                    >

                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.religion_id !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.religion_id }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.height}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="height"
                >
                    Height:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="height"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.height"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.height !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.height }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.weight}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="weight"
                >
                    Weight:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="weight"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.weight"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.weight !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.weight }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.hair_color}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="hair_color"
                >
                    Hair Color:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="hair_color"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.hair_color"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.hair_color !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.hair_color }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.eye_color}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="eye_color"
                >
                    Eye Color:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="eye_color"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.eye_color"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.eye_color !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.eye_color }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': updateCrewGeneralInfoErrors.blood_type}">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       for="blood"
                >
                    Blood Type:
                </label>
                <div class="col col-sm-4">
                    <input type="text" id="blood"
                           class="form-control form-control-xs h-1x"
                           :class="{ 'form-display': !editable }"
                           :readonly="!editable"
                           v-model="crewEdit.blood_type"
                    >
                    <span class="help-block" v-if="updateCrewGeneralInfoErrors.blood_type !== ''">
                        <small><strong>{{ updateCrewGeneralInfoErrors.blood_type }}</strong></small>
                    </span>
                </div>
            </div>

        </div>
    </form>
</template>

<script>

import { DateService } from "@/services/Utilities/DateService";
import {cloneDeep} from "lodash/lang";
import { mapActions, mapGetters } from 'vuex';
    import { vueAppMixin } from "@/mixins/vueAppMixin";
    import { formMixin } from "@/mixins/formMixin";
    import { gateMixin } from "@/mixins/gateMixin";

    export default {
        name: "GeneralInfo",
        mixins: [ vueAppMixin, formMixin, gateMixin ],
        data() {
            return {
                editable: false,
                updateCrewGeneralInfoErrors: [],
                crewEdit: {}
            }
        },

        methods: {
            ...mapActions([
                'getCivilStatusKeys',
                'getNatlKeys',
                'getReligionKeys',
                'updateCrewGeneralInfo',
                'getCrewInfo'
            ]),
            async confirmUpdateGeneralInfo() {
              if (!this.editable) {
                this.editable = true
                return
              }

              if(!await this.confirmUpdate('Are you sure you want to update this record?')) {
                return
              }

              const updatedCrewGeneralInfo = await this.updateCrewGeneralInfo({
                crew_id: this.crewEdit.id,
                last_name: this.crewEdit.last_name,
                first_name: this.crewEdit.first_name,
                middle_name: this.crewEdit.middle_name,
                nickname: this.crewEdit.nickname,
                male: this.crewEdit.male,
                birthdate: this.crewEdit.birthdate,
                birthplace: this.crewEdit.birthplace,
                civil_status_id: this.crewEdit.civil_status_id,
                country_id: this.crewEdit.country_id,
                religion_id: this.crewEdit.religion_id,
                height: this.crewEdit.height,
                weight: this.crewEdit.weight,
                hair_color: this.crewEdit.hair_color,
                eye_color: this.crewEdit.eye_color,
                blood_type: this.crewEdit.blood_type,
                extension: this.crewEdit.extension,
              });

              if(updatedCrewGeneralInfo.errors) {
                this.updateCrewGeneralInfoErrors = updatedCrewGeneralInfo.errors
                return
              }

              await this.getCrewInfo({crewId: this.crew.id})
              this.updateCrewGeneralInfoErrors = []
              this.editable = false
              this.successAlert('Crew General Info Successfully Updated', 'UPDATE')
            },
            async cancelEdit() {
              this.editable = false
              this.updateCrewGeneralInfoErrors = {}
              this.crewEdit = cloneDeep(this.crew)
            }
        },

        computed: {
            ...mapGetters([ 'crew', 'civilStatusKeys', 'natlKeys', 'religionKeys', 'nameExtensions' ]),

            crewAge() {
                return DateService.getAge(this.crew.birthdate)
            }
        },

        created() {
            this.getCivilStatusKeys();
            this.getNatlKeys();
            this.getReligionKeys();

            this.crewEdit = cloneDeep(this.crew)
        }
    }
</script>

<style scoped>

</style>
